module.exports = __webpack_public_path__ + "img/37exp.60206281.jpg";